import Vue from 'vue'
import Vuex from 'vuex'

import home from './home/homeStore.js'
import auth from './auth/authStore.js'
import dashboard from './dashboard/dashboardStore.js'
import suppliers from './suppliers/supplierStore.js'
import about from './about/aboutStore.js'
// Preferences Sections
import features from './preferences/features/featureStore'
import configurations from './preferences/configurations/configurationStore'
import openingBalance from './preferences/openingBalance/openingBalanceStore.js'
import outlets from './preferences/outlets/outletStore.js'
// Staff Sections
import staff from './staff/staff/staffStore.js'
import salesmen from './staff/salesmen/salesmanStore.js'
import systemLogs from './staff/systemLogs/systemLogStore.js'
// Customers Sections
import customersGroups from './customers/groups/groupStore.js'
import customers from './customers/customers/customerStore.js'
// Inventory Sections
import factories from './inventory/factories/factoryStore.js'
import fixedAssetTypes from './inventory/fixedAssetTypes/fixedTypeStore.js'
import fixedAssets from './inventory/fixedAssets/fixedAssetStore.js'
import productTypes from './inventory/productTypes/productTypeStore.js'
import products from './inventory/products/productStore.js'
import collections from './inventory/products/collections/collectionStore'
import rawMaterials from './inventory/rawMaterials/rawMaterialStore.js'
import mixtures from './inventory/mixtures/mixtureStore.js'
import destructedAssets from './inventory/destructedAssets/destructedAssetStore.js'
import transfers from './inventory/transfers/transferStore.js'
import receives from './inventory/receives/receiveStore.js'
import inventory from './inventory/inventory/inventoryStore.js'
import inventoryShortages from './inventory/inventoryShortages/shortageStore.js'
import inventoryNearExpiries from './inventory/inventoryNearExpiries/nearExpiryStore.js'
import inventoryExpired from './inventory/inventoryExpired/expiredStore.js'
import productions from './inventory/productions/productionStore.js'
import weightAuditors from './inventory/weightAuditor/weightAuditorStore.js'
// Accounting Sections
import dollarRates from './accounting/dollarRates/dollarRateStore.js'
import currencyExchanges from './accounting/currencyExchanges/exchangeStore.js'
import banks from './accounting/banks/bankStore.js'
import bankTransactions from './accounting/banks/transactions/bankTransactionStore.js'
import expenseTypes from './accounting/expenseTypes/expenseTypeStore.js'
import expenses from './accounting/expenses/expenseStore.js'
import taxes from './accounting/taxes/taxStore.js'
import incomeTypes from './accounting/incomeTypes/incomeTypeStore.js'
import incomes from './accounting/incomes/incomeStore.js'
import mainCashiers from './accounting/mainCashiers/mainCashierStore.js'
import cashierTransactions from './accounting/mainCashiers/transactions/cashierTransactionStore.js'
import cashierDebitCredit from './accounting/mainCashiers/debitCredit/debitCreditStore.js'
import cashiers from './accounting/cashiers/cashierStore.js'
import cashTransactions from './accounting/cashTransactions/cashTransactionStore.js'
import promoCards from './accounting/promoCards/promoCardStore.js'
import promotions from './accounting/promotions/promotionStore.js'
import purchases from './accounting/purchases/purchaseStore.js'
import purchasesReturns from './accounting/purchasesReturns/purchaseReturnStore.js'
import accountPayable from './accounting/accountPayable/payableStore.js'
import accountStatements from './accounting/accountPayable/statements/payableStatementStore.js'
import accountPayments from './accounting/accountPayable/payments/paymentStore.js'
import commissionPayable from './accounting/commissionPayable/commissionStore.js'
import accountReceivable from './accounting/accountReceivable/receivableStore.js'
import receivableStatements from './accounting/accountReceivable/statements/receivableStatementStore.js'
import receivablePayments from './accounting/accountReceivable/payments/receivablePaymentStore.js'
import generalLedger from './accounting/generalLedger/ledgerStore.js'
import generalJournal from './accounting/generalJournal/journalStore.js'
import chartOfAccounts from './accounting/chartOfAccounts/chartOfAccountStore.js'
import trialBalance from './accounting/trialBalance/trialBalanceStore.js'
import closingEntries from './accounting/closingEntries/closingEntryStore.js'
import remittances from './accounting/remittances/remittanceStore.js'
import remittanceTransactions from './accounting/remittances/transactions/remittanceTransactionStore.js'
import stockholders from './accounting/stockholders/stockholdersStore.js'
import dividends from './accounting/dividends/dividendStore.js'
import payrolls from './accounting/payrolls/payrollStore.js'
import payrollDetails from './accounting/payrolls/details/payrollDetailStore.js'
import purchasesFixedAssets from './accounting/purchasesFixedAssets/purchaseFixedStore.js'
import purchasesReturnsFixedAssets from './accounting/purchasesReturnsFixedAssets/purchaseReturnFixedStore.js'
import sales from './accounting/sales/saleStore.js'
import salesReturns from './accounting/salesReturns/saleReturnStore.js'
import quotations from './accounting/quotations/quotationStore'

// Others
import locale from './locale/localeStore.js'
import errors from './errors/errorStore.js'
import misc from './misc/miscStore.js'
import countries from './country/countryStore.js'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    home,
    auth,
    dashboard,
    suppliers,
    about,
    // Preferences Sections
    features,
    configurations,
    openingBalance,
    outlets,
    // Staff Sections
    staff,
    salesmen,
    systemLogs,
    // Customer Sections
    customersGroups,
    customers,
    // Inventory Sections
    factories,
    fixedAssetTypes,
    fixedAssets,
    productTypes,
    products,
    collections,
    rawMaterials,
    mixtures,
    destructedAssets,
    transfers,
    receives,
    inventory,
    inventoryShortages,
    inventoryNearExpiries,
    inventoryExpired,
    productions,
    weightAuditors,
    // Accounting Sections
    dollarRates,
    currencyExchanges,
    banks,
    bankTransactions,
    expenseTypes,
    expenses,
    taxes,
    incomeTypes,
    incomes,
    mainCashiers,
    cashierTransactions,
    cashierDebitCredit,
    cashiers,
    cashTransactions,
    promoCards,
    promotions,
    purchases,
    purchasesReturns,
    accountPayable,
    accountStatements,
    accountPayments,
    commissionPayable,
    accountReceivable,
    receivableStatements,
    receivablePayments,
    generalLedger,
    generalJournal,
    chartOfAccounts,
    trialBalance,
    closingEntries,
    remittances,
    remittanceTransactions,
    stockholders,
    dividends,
    payrolls,
    payrollDetails,
    purchasesFixedAssets,
    purchasesReturnsFixedAssets,
    sales,
    salesReturns,
    quotations,
    // Others
    locale,
    errors,
    misc,
    countries
  }
})
